module.exports = __webpack_public_path__ + "img/Group 2418.87c2c494.svg";